import { createAction, props } from '@ngrx/store';

export const setRoute = createAction(
	'[router] setRouter',
	props<{ current: string }>()
);
